import { render, staticRenderFns } from "./ItsOrderCustomsClear.vue?vue&type=template&id=663b8fde&scoped=true&"
import script from "./ItsOrderCustomsClear.vue?vue&type=script&lang=js&"
export * from "./ItsOrderCustomsClear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663b8fde",
  null
  
)

export default component.exports